<template>
  <div class="download-container" :style="{overflow: 'hidden', '--scale': getScale}">
    <template v-if="isAppBrowser">
      <div class="browser-content">
        <img class="download-image" :src="isIos ? require('../assets/img/ios-download.png') : require('../assets/img/android-download.png')">
        <p class="download-tips">没有安装 青柠设计客户端</p>
        <a class="download-btn" href="https://a.app.qq.com/o/simple.jsp?pkgname=com.biku.design">去下载</a>
      </div>
    </template>
    <div class="bk-download" v-else>
      <p class="link">已安装？<span class="click-block" @click="openApp">点击<span class="click-dot">此处</span>打开青柠设计</span>
      </p>
      <div class="logo-box">
        <img class="logo" src="../assets/img/design/logo.png" />
      </div>
      <p class="download-tips">若没有安装青柠设计，请先下载</p>
      <a class="download-btn" @click="download">去下载</a>
    </div>
  </div>
</template>
<script>
import {browser, androidOriOS} from '@/helper/browser';
export default {
  computed: {
    isAppBrowser () {
      let temp = browser();
      return temp === 'weixin' || temp === 'qq' || temp === 'weibo' || temp
    },
    isIos () {
      let temp = androidOriOS();
      return temp === 'ios'
    },
    getScale() {
      const clientWidth = document.body.clientWidth
      return clientWidth / 750
    }
  },
  methods: {
    openApp() {
      this.$parent.openApp()
    },
    download() {
      ajaxGet('https://api.upgrade.laidianxiu.top/api/upgrade/check?packageName=com.biku.design&versionCode=100&forceUpgrade=1&ua=test&channel=update' + '&channel=').then(dataText => {
        const dataJson = JSON.parse(dataText)
        this.downloadApk(dataJson.data.apkUrl)
      })
    },
    downloadApk(href) {
      const a = document.createElement('a')
      a.setAttribute('href', href)
      a.setAttribute('download', '青柠设计.apk')
      a.click()
    }
  }
}

function ajaxGet(url) {
  return new Promise((resolve, reject) => {
    let request
    if (window.XMLHttpRequest) {
      request = new XMLHttpRequest()
    }
    request.onreadystatechange = function () { // 状态发生变化时，函数被回调
      if (request.readyState === 4) { // 成功完成
        // 判断响应结果:
        if (request.status === 200) {
          // 成功，通过responseText拿到响应的文本:
          resolve(request.responseText)
        } else {
          // 失败，根据响应码判断失败原因:
          reject(request.status)
        }
      }
    }

    request.open('GET', url)
    request.send()
  })

}
</script>
<style lang="less" scoped>
.download-container {
  min-height: 100vh;
  background: #e5e5e5;
}
.browser-content {
  .download-image {
    width: 100%;
    object-fit: contain;
  }
  .download-tips {
    font-size: calc(42px * var(--scale));
    text-align: center;
    margin: calc(28px * var(--scale)) 0;
  }
  .download-btn {
    display: block;
    margin-left: calc(120px * var(--scale));
    background-color: #3fb59d;
    width: calc(220px * var(--scale));
    text-align: center;
    height: calc(64px * var(--scale));
    line-height: calc(64px * var(--scale));
    border-radius: calc(32px * var(--scale));
    font-size: calc(30px * var(--scale));
    color: #fff;
    text-decoration: none;
  }
}
.bk-download {
  margin-top: calc(200px * var(--scale));
  .link {
    margin-top: calc(40px * var(--scale));
    color: #999;
    font-size: calc(32px * var(--scale));
    text-align: center;
    .click-block {
      text-decoration: underline;
    }
    .click-dot {
      color: #507DAF;
    }
  }

  .logo-box {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .logo {
    margin: calc(120px * var(--scale)) auto calc(80px * var(--scale));
    width: calc(160px * var(--scale));
    height: calc(160px * var(--scale));
    border-radius: calc(20px * var(--scale));
  }
  .download-tips {
    color: #999;
    font-size: calc(28px * var(--scale));
    text-align: center;
    margin: calc(28px * var(--scale));
  }
  .download-btn {
    display: block;
    width: calc(560px * var(--scale));
    height: calc(80px * var(--scale));
    margin: 0 auto calc(100px * var(--scale));
    text-align: center;
    line-height: calc(80px * var(--scale));
    background-color: #3fb59d;
    color: #fff;
    font-size: calc(32px * var(--scale));
    border-radius: calc(4px * var(--scale));
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, .2), 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12);
    text-decoration: none;
  }
}
</style>
